/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { VehiclePagedList } from '../../models/vehicle-paged-list';

export interface GetVehicles$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The search text to filter API
 */
  search?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * TYPE : the vehicle type
 *   * ENERGY : the vehicle energy
 *   * PLATE_NUMBER : the vehicle plate number
 *   * PARK_NUMBER : the vehicle park number
 */
  sortFieldName?: 'TYPE' | 'ENERGY' | 'PLATE_NUMBER' | 'PARK_NUMBER' | 'SUBSCRIPTION' | 'AUTH_SUPPORT';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
}

export function getVehicles(http: HttpClient, rootUrl: string, params?: GetVehicles$Params, context?: HttpContext): Observable<StrictHttpResponse<VehiclePagedList>> {
  const rb = new RequestBuilder(rootUrl, getVehicles.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VehiclePagedList>;
    })
  );
}

getVehicles.PATH = '/vehicles/search';
